/**
 * Menu that is triggered from the site header and shows profile-level nav items
 */
import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/styles';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Switch from '@material-ui/core/Switch';
import DeleteIcon from '@material-ui/icons/Delete';
// import LockIcon from '@material-ui/icons/Lock';

import roleDisabled from 'services/roleDisabled/index';
import { OWNER } from 'constants/roles';
import { lightTheme } from 'components/App/App.theme';
import WithSpecifiedTheme from 'components/WithSpecifiedTheme/WithSpecifiedTheme';

const propTypes = {
  classes: PropTypes.shape({}).isRequired,
  handleConfirmDelete: PropTypes.func.isRequired,
  userRoles: PropTypes.arrayOf(PropTypes.string).isRequired,
  anchorEl: PropTypes.oneOfType([PropTypes.object]),
  onClose: PropTypes.func.isRequired,
  isOwner: PropTypes.bool.isRequired,
  userId: PropTypes.string.isRequired,
  userORv4ID: PropTypes.string,
  orgORv4ID: PropTypes.string,
  updateUsersState: PropTypes.func.isRequired,
};

const defaultProps = {
  anchorEl: null,
  userORv4ID: null,
  orgORv4ID: null,
};

export function UnstyledUserActionsMenu({
  classes,
  anchorEl,
  onClose,
  handleConfirmDelete,
  userRoles,
  isOwner,
  userId,
  userORv4ID,
  orgORv4ID,
  updateUsersState,
}) {
  // Not sure this check is needed since only owners can see the users screen anyway
  const allowedUserRoles = [OWNER];
  const roleIsDisabled = roleDisabled(userRoles, allowedUserRoles);

  const canAccessDedicated = Boolean(orgORv4ID) && Boolean(userORv4ID) && orgORv4ID === userORv4ID;

  // disable menu in order to not show empty options, until we have another MenuItem
  return (
    <Menu
      className={classes.root}
      classes={{ list: classes.list }}
      open={!!anchorEl && !roleIsDisabled && !isOwner}
      onClose={onClose}
      anchorEl={anchorEl}
      anchorOrigin={{ horizontal: 'right', vertical: 50 }}
      disableAutoFocusItem
      getContentAnchorEl={null}
    >
      {roleIsDisabled || !orgORv4ID ? null : (
        <MenuItem className={classes.menuItem} classes={{ selected: classes.selectedLink }}>
          GRANT ACCESS TO DEDICATED
          <Switch
            className={classes.grantSwitch}
            checked={canAccessDedicated}
            onChange={() =>
              updateUsersState({ accessDedicated: !canAccessDedicated }, userId, orgORv4ID)
            }
          />
        </MenuItem>
      )}
      {/* <MenuItem
        className={classes.menuItem}
        component="a"
        onClick={onClose}
        classes={{ selected: classes.selectedLink }}
      >
        REQUEST PASSWORD CHANGE
        <LockIcon className={classes.lockIcon} />
      </MenuItem> */}
      {roleIsDisabled ? null : (
        <MenuItem
          className={classes.menuItem}
          onClick={handleConfirmDelete}
          classes={{ selected: classes.selectedLink }}
        >
          DELETE USER
          <DeleteIcon className={classes.deleteIcon} />
        </MenuItem>
      )}
    </Menu>
  );
}

UnstyledUserActionsMenu.propTypes = propTypes;
UnstyledUserActionsMenu.defaultProps = defaultProps;

const styles = (theme) => ({
  root: {
    padding: 0,
    marginLeft: -10,
    marginTop: -20,
  },
  list: {
    paddingTop: 0,
    paddingBottom: 0,
  },
  selectedLink: {
    backgroundColor: theme.palette.action.selected,
  },
  menuItem: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  lockIcon: {
    color: theme.customColors.mediumGrey,
    marginLeft: theme.spacing(3),
  },
  deleteIcon: {
    color: theme.customColors.mediumGrey,
    marginLeft: theme.spacing(5),
  },
  grantSwitch: {
    marginLeft: theme.spacing(5),
    marginRight: theme.spacing(-2),
  },
  profileTextContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  email: {
    fontSize: '14px',
    color: theme.customColors.mediumGrey,
  },
});

export default WithSpecifiedTheme(lightTheme)(withStyles(styles)(UnstyledUserActionsMenu));
